import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { empty as o, insertBefore as i } from "../../core/domUtils.js";
import e from "../../core/Evented.js";
import n from "../../core/Handles.js";
import { init as r } from "../../core/watchUtils.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as a } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as d } from "../../core/accessorSupport/decorators/subclass.js";
import p from "./Component.js";
import { getCalciteThemeClass as c, isRTL as l } from "../../widgets/support/widgetUtils.js";
var h = {
  left: 0,
  top: 0,
  bottom: 0,
  right: 0
},
    m = {
  bottom: 30,
  top: 15,
  right: 15,
  left: 15
},
    u = "manual",
    f = {
  ui: "esri-ui",
  corner: "esri-ui-corner",
  innerContainer: "esri-ui-inner-container",
  manualContainer: "esri-ui-manual-container",
  cornerContainer: "esri-ui-corner-container",
  topLeft: "esri-ui-top-left",
  topRight: "esri-ui-top-right",
  bottomLeft: "esri-ui-bottom-left",
  bottomRight: "esri-ui-bottom-right"
};

function _(t) {
  return t && !t._started && "function" == typeof t.postMixInProperties && "function" == typeof t.buildRendering && "function" == typeof t.postCreate && "function" == typeof t.startup;
}

function g(t) {
  var o = t,
      i = "object" == typeof o && null !== o && Object.getPrototypeOf(o);
  return (null === i || i === Object.prototype) && ("component" in o || "index" in o || "position" in o) ? t : null;
}

function y(t, _ref) {
  var o = _ref.top,
      i = _ref.bottom,
      e = _ref.left,
      n = _ref.right;
  t.style.top = o, t.style.bottom = i, t.style.left = e, t.style.right = n;
}

var C = /*#__PURE__*/function (_e$EventedAccessor) {
  _inherits(C, _e$EventedAccessor);

  var _super = _createSuper(C);

  function C(t) {
    var _this;

    _classCallCheck(this, C);

    _this = _super.call(this, t), _this._cornerNameToContainerLookup = {}, _this._positionNameToContainerLookup = {}, _this._components = new Array(), _this._componentToKey = new Map(), _this._handles = new n(), _this.view = null, _this._initContainers();
    return _this;
  }

  _createClass(C, [{
    key: "initialize",
    value: function initialize() {
      this._handles.add([r(this, "view.padding, container", this._applyViewPadding.bind(this)), r(this, "padding", this._applyUIPadding.bind(this))]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.container = null;

      var _iterator = _createForOfIteratorHelper(this._components),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;

          _t.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._components.length = 0, this._handles.destroy(), this._componentToKey.clear();
    }
  }, {
    key: "container",
    set: function set(t) {
      var i = this._get("container");

      t !== i && (t && (t.classList.add(f.ui), t.classList.add(c()), this._attachContainers(t)), i && (i.classList.remove(f.ui), y(i, {
        top: "",
        bottom: "",
        left: "",
        right: ""
      }), o(i)), this._set("container", t));
    }
  }, {
    key: "height",
    get: function get() {
      var t = this.get("view.height") || 0;
      if (0 === t) return t;

      var o = this._getViewPadding(),
          i = o.top + o.bottom;

      return Math.max(t - i, 0);
    }
  }, {
    key: "padding",
    get: function get() {
      return this._get("padding");
    },
    set: function set(t) {
      t ? this._override("padding", t) : this._clearOverride("padding");
    }
  }, {
    key: "castPadding",
    value: function castPadding(t) {
      return "number" == typeof t ? {
        bottom: t,
        top: t,
        right: t,
        left: t
      } : _objectSpread(_objectSpread({}, m), t);
    }
  }, {
    key: "width",
    get: function get() {
      var t = this.get("view.width") || 0;
      if (0 === t) return t;

      var o = this._getViewPadding(),
          i = o.left + o.right;

      return Math.max(t - i, 0);
    }
  }, {
    key: "add",
    value: function add(t, o) {
      var _this2 = this,
          _n,
          _o;

      var i, e;
      if (Array.isArray(t)) return void t.forEach(function (t) {
        return _this2.add(t, o);
      });
      var n = g(t);
      n && (_n = n, i = _n.index, o = _n.position, t = _n.component, e = _n.key, _n), o && "object" == typeof o && (_o = o, i = _o.index, e = _o.key, o = _o.position, _o), !t || o && !this._isValidPosition(o) || this._add(t, o, i, e);
    }
  }, {
    key: "remove",
    value: function remove(t, o) {
      var _this3 = this;

      if (!t) return;
      if (Array.isArray(t)) return t.map(function (t) {
        return _this3.remove(t, o);
      });

      var i = this._find(t);

      if (i) {
        var _e = this._componentToKey;
        if (_e.has(t) && _e.get(t) !== o) return;

        var _n2 = this._components.indexOf(i);

        return i.node.parentNode && i.node.parentNode.removeChild(i.node), this._componentToKey.delete(t), this._components.splice(_n2, 1)[0];
      }
    }
  }, {
    key: "empty",
    value: function empty(t) {
      var _this4 = this;

      if (Array.isArray(t)) return t.map(function (t) {
        return _this4.empty(t);
      }).reduce(function (t, o) {
        return t.concat(o);
      });

      if ((t = t || u) === u) {
        return Array.prototype.slice.call(this._manualContainer.children).filter(function (t) {
          return !t.classList.contains(f.corner);
        }).map(function (t) {
          return _this4.remove(t);
        });
      }

      return this._isValidPosition(t) ? Array.prototype.slice.call(this._cornerNameToContainerLookup[t].children).map(this.remove, this) : null;
    }
  }, {
    key: "move",
    value: function move(t, o) {
      var _this5 = this;

      if (Array.isArray(t) && t.forEach(function (t) {
        return _this5.move(t, o);
      }), !t) return;
      var i;
      var e = g(t) || g(o);
      if (e && (i = e.index, o = e.position, t = e.component || t), o && !this._isValidPosition(o)) return;
      var n = this.remove(t);
      n && this.add(n, {
        position: o,
        index: i
      });
    }
  }, {
    key: "find",
    value: function find(t) {
      if (!t) return null;

      var o = this._findById(t);

      return o && (o.widget || o.node);
    }
  }, {
    key: "getPosition",
    value: function getPosition(t) {
      for (var _o2 in this._positionNameToContainerLookup) {
        if (this._positionNameToContainerLookup[_o2].contains(t)) return _o2;
      }

      return null;
    }
  }, {
    key: "_add",
    value: function _add(t, o, i, e) {
      t instanceof p || (t = new p({
        node: t
      })), this._place({
        component: t,
        position: o,
        index: i
      }), this._components.push(t), e && this._componentToKey.set(t, e);
    }
  }, {
    key: "_find",
    value: function _find(t) {
      return t ? t instanceof p ? this._findByComponent(t) : "string" == typeof t ? this._findById(t) : this._findByNode(t.domNode || t) : null;
    }
  }, {
    key: "_getViewPadding",
    value: function _getViewPadding() {
      return this.get("view.padding") || h;
    }
  }, {
    key: "_attachContainers",
    value: function _attachContainers(t) {
      t.appendChild(this._innerContainer), t.appendChild(this._manualContainer);
    }
  }, {
    key: "_initContainers",
    value: function _initContainers() {
      var t = document.createElement("div");
      t.classList.add(f.innerContainer), t.classList.add(f.cornerContainer);
      var o = document.createElement("div");
      o.classList.add(f.innerContainer), o.classList.add(f.manualContainer);
      var i = document.createElement("div");
      i.classList.add(f.topLeft), i.classList.add(f.corner), t.appendChild(i);
      var e = document.createElement("div");
      e.classList.add(f.topRight), e.classList.add(f.corner), t.appendChild(e);
      var n = document.createElement("div");
      n.classList.add(f.bottomLeft), n.classList.add(f.corner), t.appendChild(n);
      var r = document.createElement("div");
      r.classList.add(f.bottomRight), r.classList.add(f.corner), t.appendChild(r), this._innerContainer = t, this._manualContainer = o;
      var s = l();
      this._cornerNameToContainerLookup = {
        "top-left": i,
        "top-right": e,
        "bottom-left": n,
        "bottom-right": r,
        "top-leading": s ? e : i,
        "top-trailing": s ? i : e,
        "bottom-leading": s ? r : n,
        "bottom-trailing": s ? n : r
      }, this._positionNameToContainerLookup = _objectSpread({
        manual: o
      }, this._cornerNameToContainerLookup);
    }
  }, {
    key: "_isValidPosition",
    value: function _isValidPosition(t) {
      return !!this._positionNameToContainerLookup[t];
    }
  }, {
    key: "_place",
    value: function _place(t) {
      var o = t.component,
          e = t.position || u,
          n = t.index,
          r = this._positionNameToContainerLookup[e],
          s = n > -1;
      if (_(o.widget) && o.widget.startup(), !s) return void r.appendChild(o.node);
      var a = Array.prototype.slice.call(r.children);
      if (0 === n) return void (r.firstChild ? i(o.node, r.firstChild) : r.appendChild(o.node));
      n >= a.length ? r.appendChild(o.node) : i(o.node, a[n]);
    }
  }, {
    key: "_applyViewPadding",
    value: function _applyViewPadding() {
      var t = this.container;
      t && y(t, this._toPxPosition(this._getViewPadding()));
    }
  }, {
    key: "_applyUIPadding",
    value: function _applyUIPadding() {
      var t = this._innerContainer;
      t && y(t, this._toPxPosition(this.padding));
    }
  }, {
    key: "_toPxPosition",
    value: function _toPxPosition(t) {
      return {
        top: this._toPxUnit(t.top),
        left: this._toPxUnit(t.left),
        right: this._toPxUnit(t.right),
        bottom: this._toPxUnit(t.bottom)
      };
    }
  }, {
    key: "_toPxUnit",
    value: function _toPxUnit(t) {
      return 0 === t ? "0" : t + "px";
    }
  }, {
    key: "_findByComponent",
    value: function _findByComponent(t) {
      var o,
          i = null;
      return this._components.some(function (e) {
        return o = e === t, o && (i = e), o;
      }), i;
    }
  }, {
    key: "_findById",
    value: function _findById(t) {
      var o,
          i = null;
      return this._components.some(function (e) {
        return o = e.id === t, o && (i = e), o;
      }), i;
    }
  }, {
    key: "_findByNode",
    value: function _findByNode(t) {
      var o,
          i = null;
      return this._components.some(function (e) {
        return o = e.node === t, o && (i = e), o;
      }), i;
    }
  }]);

  return C;
}(e.EventedAccessor);

t([s()], C.prototype, "container", null), t([s()], C.prototype, "height", null), t([s({
  value: m
})], C.prototype, "padding", null), t([a("padding")], C.prototype, "castPadding", null), t([s()], C.prototype, "view", void 0), t([s()], C.prototype, "width", null), C = t([d("esri.views.ui.UI")], C);
var v = C;
export { v as default };